
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
// import contacts from '../contact/contacts-short.js'
// import contacts from '../contact/contacts-short.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    provinces: ['QC', 'ON', 'NO TAXES', 'NB', 'BC', 'NL', 'NS', 'PE', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT', 'TPS'],
    user: null,
    userInfo: null,
    allContacts: {},
    search: null,
    searchFields: {},
    searchLastPage: 0,
    authorization: null
  },
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js